import React, { useContext, useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import { momentTimeFormater } from '../../../utils/dateHelper';
import _, { get as LodashGet } from 'lodash';
import myClasses from '../SmartCharging.module.css';
import Typography from '../../../components/Typography/Typography';
import { SCService } from '../../../services/SCService';
import { useLoader } from '../../../hooks';
import { toast } from 'react-toastify';
import { UilSync } from '@iconscout/react-unicons';

const LIMIT = 15;

const SessionLogModal = ({ setOpen, sessionId = '' }) => {
    const [startLoader, stopLoader] = useLoader();

    const [data, setData] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        getLogs();
    }, [skip, sessionId]);

    const getLogs = () => {
        if (sessionId) {
            const params = {
                limit: LIMIT,
                skip,
            };
            SCService.GetLogs(sessionId, params, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => {
        const processedData = _.get(data, ['data', 'data'], []).map((item) => ({
            sessionId: item.sessionId,
            message: item.message,
            timestamp: momentTimeFormater(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        }));
        setTotalCount(_.get(data, ['data', 'count'], 0));
        setData(processedData);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div style={{ minWidth: '60vw', maxHeight: '90vh', overflowY: 'auto' }}>
            <div className={myClasses.FilterContainer}>
                <div className={myClasses.HeadingContainer}>
                    <Typography content={`OCPI Logs`} />
                </div>
                <div onClick={() => getLogs()}>
                    <UilSync style={{ color: 'var(--color-primary)', cursor: 'pointer' }} size="1.2vw" />
                </div>
            </div>
            <Table
                head={['SESSION ID', 'MESSAGE', 'TIMESTAMP (CET)']}
                keys={['sessionId', 'message', 'timestamp']}
                data={data}
                page={page}
                Pagination={true}
                limit={LIMIT}
                handlePageChange={handlePageChange}
                totalCount={totalCount}
            />
            <div className={myClasses.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>

        </div>
    );
};

export default SessionLogModal;
